import { useEffect, useState } from 'react'

function useColorModeValue(lightValue: string, darkValue: string): string {
  const [value, setValue] = useState(lightValue)

  useEffect(() => {
    // Check if dark mode is enabled
    const isDarkMode = document.documentElement.classList.contains('dark')
    setValue(isDarkMode ? darkValue : lightValue)

    // Optional: Listen for changes to color mode
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'class') {
          const isDark = document.documentElement.classList.contains('dark')
          setValue(isDark ? darkValue : lightValue)
        }
      }
    })

    observer.observe(document.documentElement, { attributes: true })
    return () => observer.disconnect()
  }, [lightValue, darkValue])

  return value
}

export default useColorModeValue
